import { makeAutoObservable, runInAction } from "mobx";
import CreateRmaService, { IOutOfPolicyResultDto } from "../../../services/api/create-rma-service";
import { TYPE, rootContainer } from "../../../services/container/root";
import RmaRequestStore, {ICreateRmaDto} from "./rma-request-store";

export class CreateRmaEligibilityStore {

	private _eligibilityCallsCounter: number = 0;
	private _eligibilityResponse?: IOutOfPolicyResultDto;
	private _isEligibilityInProgress: boolean = false;    
	private _prevCompareString?: string;

    constructor(private _rmaRequestStore: RmaRequestStore) {
        makeAutoObservable(this, {}, { autoBind: true });        
		this._prevCompareString = compareStringFromModel(this._rmaRequestStore.requestModel());
    }

	private get createRmaService(): CreateRmaService { return rootContainer.get<CreateRmaService>(TYPE.CreateRmaService); }

    public get isInProgress():boolean { return this._isEligibilityInProgress; }
    public get isOutOfPolicy(): boolean { return this._eligibilityResponse?.is_out_of_policy ?? false; }
	

	public isGroupOutOfPolicy(groupId: string): boolean {
		const group = this._eligibilityResponse?.return_items?.find(returnItem => returnItem.group_id === groupId);
		return group?.available_policies?.length === 0;
	}
    

    public shouldCheck() {
		const currentCompString = compareStringFromModel(this._rmaRequestStore.requestModel());
		const should = this._prevCompareString !== currentCompString;
		runInAction(() => {
			this._prevCompareString = currentCompString;
		});
		return should;
    }

	async checkEligibility() {
		const request = this._rmaRequestStore.requestModel();
		if (!request) {
			return;
		}

		/** this property change does not require run in action - not exposed to components */
		this._eligibilityCallsCounter += 1;
		let currentCounter = this._eligibilityCallsCounter;
		let response: IOutOfPolicyResultDto|undefined;

		try {
			/** wraping in run in action since we read this property in component and the method runs from autorun */
			runInAction(() => {
				this._isEligibilityInProgress = true;
			});
			response = await this.createRmaService.isRmaRequestOutOfPolicy(request);
        }
		catch (e) {
			console.error(e);
		}

		/** mechansim to prevent previous call to update state, it can happen if response from 1 request returned after response from 2nd request */
		/** makes sure we always have response from last request */
		if (currentCounter !== this._eligibilityCallsCounter) {
			return;
		}

		runInAction(() => {
			if (response) {
				this._eligibilityResponse = response;
			}
			this._isEligibilityInProgress = false;
		});
	}

}

function compareStringFromModel(dto: ICreateRmaDto): string|undefined {
	/** choose props from request */
	const { items } = dto;
	return JSON.stringify(items);
}
